import styled, { keyframes } from 'styled-components';

const spin = keyframes`
  to { transform: rotate(360deg); }
`;

export const Container = styled.div<{ $fullPage?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: ${({ theme }) => theme.spacing.xxl};
  gap: ${({ theme }) => theme.spacing.md};
  ${({ $fullPage }) =>
    $fullPage &&
    `
    min-height: 100vh;
    width: 100%;
  `}
`;

export const Spinner = styled.div`
  width: 3.6rem;
  height: 3.6rem;
  border-radius: 50%;
  border: 0.3rem solid ${({ theme }) => theme.colors.border};
  border-top-color: ${({ theme }) => theme.colors.accent};
  animation: ${spin} 0.7s linear infinite;
`;

export const Message = styled.div`
  font-size: 1.3rem;
  color: ${({ theme }) => theme.colors.slateGrey};
  font-weight: 500;
`;
